module.exports = __webpack_public_path__ + "img/caohuihui.4878947c.jpg";